<template>
  <div class="grid-view">
    <div class="main-content fiscal-period">
      <div class="section operations">
        <div class="filters">
          <el-button type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button type="primary" @click="refreshHandler">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
          <div class="operations" style="margin-top: 10px">
            <el-form style="flex-direction: row;padding-left: 5px;">
              <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_VoucherLine') }}</span>
              <el-select v-model="accountSet.voucherLines" style="width: 170px">
                <el-option
                  v-for="(item,index) in condition"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form>
          </div>
          <div class="section form-column">
            <el-form style="flex-direction: row;padding-bottom: 10px;">
              <span style="margin-right: 5px">{{ $t('CargoMsg.Cargo_UseRmbEntrytypeByInvoice') }}</span>
              <el-input v-model="accountSet.useRmbEntrytypeByInvoice" style="width: 200px;" />
              <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_UseRmbEntrytypeByInvoiceTip') }}</span>
            </el-form>
            <el-form style="flex-direction: row;padding-bottom: 10px;">
              <span style="margin-right: 5px">{{ $t('CargoMsg.Cargo_UseRmbEntrytypeByFact') }}</span>
              <el-input v-model="accountSet.useRmbEntrytypeByFact" style="width: 200px;" />
              <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_UseRmbEntrytypeByFactTip') }}</span>
            </el-form>
            <el-form style="flex-direction: row;padding-bottom: 10px;">
              <span style="margin-right: 5px">{{ $t('CargoMsg.Cargo_UseRmbEntrytypeByPre') }}</span>
              <el-input v-model="accountSet.useRmbEntrytypeByPre" style="width: 188px;" />
              <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_UseRmbEntrytypeByPreTip') }}</span>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as accountSetApi from '@/api/financeManage/accountSet'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'VoucherLineSetting',
  props: {
    accountSet: { type: Object, default: null }
  },
  data() {
    return {
      condition: [
        { name: '4', value: 4 },
        { name: '5', value: 5 },
        { name: '6', value: 6 }
      ]
    }
  },
  methods: {
    async saveHandler() {
      if (!this.accountSet) {
        this.$message.info(this.$t('FinanceManage.AccountNotFound'))
        return
      }
      const loading = getLoading()
      const accountSet = await accountSetApi.detail({ uuid: this.accountSet.uuid }).then(resp => resp.data)
      accountSet.voucherLines = this.accountSet.voucherLines
      accountSet.useRmbEntrytypeByInvoice = this.accountSet.useRmbEntrytypeByInvoice
      accountSet.useRmbEntrytypeByFact = this.accountSet.useRmbEntrytypeByFact
      accountSet.useRmbEntrytypeByPre = this.accountSet.useRmbEntrytypeByPre
      accountSetApi.save(accountSet).then(resp => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).finally(() => loading.close())
    },
    async refreshHandler() {
      const loading = getLoading()
      const accountSet = await accountSetApi.detail({ uuid: this.accountSet.uuid }).then(resp => resp.data)
      if (accountSet) {
        this.accountSet.voucherLines = accountSet.voucherLines
        this.accountSet.useRmbEntrytypeByInvoice = accountSet.useRmbEntrytypeByInvoice
        this.accountSet.useRmbEntrytypeByFact = accountSet.useRmbEntrytypeByFact
        this.accountSet.useRmbEntrytypeByPre = accountSet.useRmbEntrytypeByPre
      }
      loading.close()
    }
  }
}
</script>

<style scoped>

</style>
